// components/ArticleList.tsx
import React, { } from 'react';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import TextFieldCustom from '../elements/TextFieldCustom';
import BotonRedondo from '../elements/BotonFabMenu';
import { dateToDateDB } from '@/util/MagicDate';
import SendIcon from '@mui/icons-material/Send';
import { useTranslation } from 'next-i18next';
import WarningIcon from '@mui/icons-material/Warning';
import { MensajeChat_ChatBot, PreguntaChatBot, RespuestaChatBot } from '@/objects/ChatBot';
import RowMensajeChatBot from '../elements/listas/lista_mensajes/RowMensajeChatBot';
import { useNotificationContext } from '@/context/NotificationContext';
import { baseURLImages } from '@/util/BaseURL';
import { Card } from '@mui/material';
import Texto from '../elements/Texto';
import { black } from '@/constants/Colors';
import styles from '../../css/ChatAyuda.module.css';

interface Props {
  locale: string;
}

const ChatAyuda: React.FC<Props> = ({ locale }) => {
  const { t } = useTranslation();

  const { chatBotQueries } = useServices();
  const { userData } = useNotificationContext();

  const [mensajesChatBot, setMensajesChatBot] = React.useState<MensajeChat_ChatBot[]>([]);

  const [mensajeEnviar, setMensajeEnviar] = React.useState<string>("");
  const [desactivarBoton, setDesactivarBoton] = React.useState<boolean>(false);

  function scrollAbajo() {
    const element = document.getElementById("chat");
    if (element != null) {
      element.scrollTop = element.scrollHeight;
    }
  }

  function enviarMensaje() {
    if (mensajeEnviar == "") return;

    const objEnviarChat: PreguntaChatBot = {
      user_question: mensajeEnviar,
      idioma: locale
    }

    const objetoMensajePropio: MensajeChat_ChatBot = {
      id_autor: userData?.id_user!,
      imagen_usuario: userData?.image!,
      texto: mensajeEnviar,
      fecha: dateToDateDB(new Date())
    }

    setDesactivarBoton(true);
    chatBotQueries?.preguntarChatBot(objEnviarChat).then((response: AxiosResponse<RespuestaChatBot>) => {
      if (response.status == 200) {
        const respuestaChatBot: RespuestaChatBot = response.data;
        const objetoMensajeChatBot: MensajeChat_ChatBot = {
          id_autor: 0,
          imagen_usuario: baseURLImages + "/images/chatbot.png",
          texto: respuestaChatBot.output,
          fecha: dateToDateDB(new Date())
        }
        setMensajesChatBot([...mensajesChatBot, objetoMensajePropio, objetoMensajeChatBot]);
        setMensajeEnviar("");
        setDesactivarBoton(false);
        setTimeout(() => {
          scrollAbajo();
        }, 500);
      } else {
        const objetoMensajeChatBot: MensajeChat_ChatBot = {
          id_autor: 0,
          imagen_usuario: baseURLImages + "/images/chatbot.png",
          texto: t("menu:secciones.chat_ayuda.error_chatbot"),
          fecha: dateToDateDB(new Date())
        }
        setMensajesChatBot([...mensajesChatBot, objetoMensajeChatBot]);
        setDesactivarBoton(false);
      }
    }).catch((error: any) => {
      console.log("Error en enviar mensaje", error);
      const objetoMensajeChatBot: MensajeChat_ChatBot = {
        id_autor: 0,
        imagen_usuario: baseURLImages + "/images/chatbot.png",
        texto: t("menu:secciones.chat_ayuda.error_chatbot"),
        fecha: dateToDateDB(new Date())
      }
      setMensajesChatBot([...mensajesChatBot, objetoMensajeChatBot]);
      setDesactivarBoton(false);
    }
    );
  }

  return (
    <div className={styles.container}>
      <Card className={styles.warning}>
        <WarningIcon />
        <Texto html color={black}>
          {t("menu:secciones.chat_ayuda.disclaimer")}
        </Texto>
      </Card>

      <div id="chat" className={styles.messages}>
        {mensajesChatBot?.map((mensaje: MensajeChat_ChatBot, index: number) => (
          <div key={index} className={styles.messageWrapper}>
            <RowMensajeChatBot mensaje={mensaje} />
          </div>
        ))}
      </div>

      <div className={styles.inputBar}>
        <div className={styles.inputContainer}>
          <TextFieldCustom
            label={t("menu:secciones.mensajes.escribir_mensaje")}
            value={mensajeEnviar}
            setValue={setMensajeEnviar}
            onKeyDown={(event: React.KeyboardEvent) => {
              if (event.key === "Enter" && !desactivarBoton) {
                enviarMensaje();
              }
            }}
          />
        </div>
        <div className={styles.buttonContainer}>
          <BotonRedondo
            icon={<SendIcon />}
            textoBoton={t("menu:secciones.mensajes.enviar")}
            onClick={() => {
              if (!desactivarBoton) {
                enviarMensaje();
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}
export default ChatAyuda;
